import React from "react"
import styled from "styled-components"

import { MobergTheme, getColors } from "../../../../../Components/MobergThemes/MobergColors"
import {
	MobergFontFamily,
	MobergFontSize,
} from "../../../../../Components/MobergFont/MobergFont"
import { MobergColumn } from "../../../../../Moberg"
import { MonitorPreset } from "../../../../../Pages/Data/Visualize/DataReview/Calibration/types"
import { MANUAL_PRESET, MONITOR_PRESETS } from "../../../../../Pages/Data/Visualize/DataReview/Calibration/constants"
import { MobergAnimationTiming, MobergAnimationCurve } from "../../../../../Components/MobergAnimation/MobergAnimation"

interface MonitorPresetSelectorProps {
	activePreset: string | null
	applyPreset: (preset: MonitorPreset) => void
	onSelectManual: () => void
}

export const MonitorPresetSelector: React.FC<MonitorPresetSelectorProps> = ({
	activePreset,
	applyPreset,
	onSelectManual,
}) => {
	return (
		<MobergColumn gap={12} style={{ width: "100%" }}>
			<MobergColumn gap={12} style={{ width: "100%" }}>
				{MONITOR_PRESETS.map(preset => (
					<PresetButton
						key={preset.label}
						onClick={() => applyPreset(preset)}
						$isActive={activePreset === preset.label}
					>
						<MonitorIcon>
							<rect x="2" y="3" width="28" height="16" rx="1" />
							<rect x="13" y="19" width="6" height="1" />
						</MonitorIcon>
						<span>{preset.label}</span>
					</PresetButton>
				))}
				<PresetButton
					onClick={onSelectManual}
					$isActive={activePreset === MANUAL_PRESET}
				>
					<MonitorIcon>
						<rect x="2" y="3" width="28" height="16" rx="1" />
						<rect x="10" y="19" width="12" height="1" />
					</MonitorIcon>
					<span>{MANUAL_PRESET}</span>
				</PresetButton>
			</MobergColumn>
		</MobergColumn>
	)
}

const PresetButton = styled.button<{ $isActive?: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	width: 100%;
	aspect-ratio: 1.2;
	padding: 14px 18px;
	background: ${({ $isActive }) =>
		$isActive ? getColors(MobergTheme.BLUE).noFill.hover : "transparent"};
	border: 2px solid
		${({ $isActive }) => ($isActive ? getColors(MobergTheme.BLUE).main : "var(--color-border-default)")};
	border-radius: 4px;
	font-size: ${MobergFontSize.REGULAR};
	font-family: ${MobergFontFamily.HEADER};
	font-weight: 600;
	color: ${({ $isActive }) => ($isActive ? getColors(MobergTheme.BLUE).main : "var(--color-text-primary)")};
	cursor: pointer;
	transition: all ${MobergAnimationTiming.VERY_FAST} ${MobergAnimationCurve.EASE_IN};

	&:hover {
		background: ${getColors(MobergTheme.BLUE).noFill.hover};
		border-color: ${getColors(MobergTheme.BLUE).main};
		color: ${getColors(MobergTheme.BLUE).main};
	}
`

const MonitorIcon = styled.svg.attrs({
	width: 32,
	height: 24,
	viewBox: "0 0 32 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
})`
	rect {
		stroke: currentColor;
		stroke-width: 2;
	}
`
